import { SelectItemOptions } from "@usitsdasdesign/dds-ng/select";

export enum EComponentsMode {
    dark = 'dark',
    light = 'light'
}

export interface ThemesItem extends SelectItemOptions {
    colors: string[];
}